import { call, put } from "redux-saga/effects";
import { feeService } from "../services/feeService";
import { feeConstants } from "../actions/constants/feeConstants";
import { commonConstants } from "../actions/constants/commonConstants";

function* getFeeParams(action: any): any {
  try {
    const response = yield call(feeService.getFeeParams, action.payload);
    if (response.success) {
      yield put({ type: feeConstants.getFeeParamsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: feeConstants.getFeeParamsFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: feeConstants.getFeeParamsFailure, payload: error });
  }
}

function* createFee(action: any): any {
  try {
    const response = yield call(feeService.createFee, action.payload);
    if (response.success) {
      yield put({ type: feeConstants.createFeeSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: feeConstants.createFeeFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: feeConstants.createFeeFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error.message });
  }
}

function* deleteFee(action: any): any {
  try {
    const response = yield call(feeService.deleteFee, action.payload);
    if (response.success) {
      yield put({ type: feeConstants.deleteFeeSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: feeConstants.deleteFeeFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: feeConstants.deleteFeeFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error.message });
  }
}

function* getFeeView(action: any): any {
  try {
    const response = yield call(feeService.getFeeView, action.payload);
    if (response.success) {
      yield put({ type: feeConstants.feeViewSuccess, payload: response.resultObject });
    } else {
      yield put({ type: feeConstants.feeViewFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: feeConstants.feeViewFailure, payload: error });
  }
}

function* getStudentFeeSummary(action: any): any {
  try {
    const response = yield call(feeService.getStudentFeeSummary, action.payload);
    if (response.success) {
      yield put({ type: feeConstants.getStudentFeeSummarySuccess, payload: response.resultObject });
    } else {
      yield put({ type: feeConstants.getStudentFeeSummaryFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: feeConstants.getStudentFeeSummaryFailure, payload: error });
  }
}

function* getEnrollmentFeeHistory(action: any): any {
  try {
    const response = yield call(feeService.getEnrollmentFeeHistory, action.payload);
    if (response.success) {
      yield put({ type: feeConstants.getEnrollmentFeeHistorySuccess, payload: response.resultObject });
    } else {
      yield put({ type: feeConstants.getEnrollmentFeeHistoryFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: feeConstants.getEnrollmentFeeHistoryFailure, payload: error });
  }
}

export const feeSaga = {
  getFeeParams,
  createFee,
  deleteFee,
  getFeeView,
  getStudentFeeSummary,
  getEnrollmentFeeHistory,
};
